import Helper from "./Helper.js";
import { Power1 } from "gsap";

//const drawEasing = Sine.easeInOut;

const nonMovingActions = ["text", "rectangle", "circle", "polygon", "triangle"];
const maskedActions = ["dribble", "pass", "screen", "cut", "shot"];

const addPause = (timeline, duration, pauses = []) => {
  let newPause = {
    start: timeline.duration(),
  };
  timeline.to(
    {},
    {
      duration,
    }
  );
  newPause.end = timeline.duration();
  newPause.duration = duration;

  pauses.push(newPause);
  return newPause;
};

const drawStaticActions = (prefix, timeline, step, inAnimator = false) => {
  if (!step) return;
  //check if all object in step (array) are of type "text", "rectangle", "circle", "polygon", "triangle"
  if (step.every((x) => nonMovingActions.includes(x?.action?.subType))) {
    for (let subStep of step) {
      drawActions(prefix, timeline, subStep.action, inAnimator);
    }
  }
};

const drawEasing = Power1.easeOut;
const createAnimationSteps = (steps) => {
  let animationSteps = [];

  for (let i = 0; i < steps.length; i++) {
    let previouseStep = steps[i - 1];

    let step = steps[i];
    if (
      (previouseStep && step.action.sameTime) ||
      (previouseStep?.action?.animationType === "end" &&
        step?.action?.animationType === "end")
    ) {
      animationSteps[animationSteps.length - 1].push(step);
    } else {
      animationSteps.push([step]);
    }
  }
  return animationSteps;
};

const moveActions = (prefix, timeline, subStep, startTS, court) => {
  let { changes, players, action } = subStep;

  let playerTeam = players.find((x) => x.id === changes.id)?.team;

  if (changes) {
    let nextArrowPos = changes.movementArrow;

    let animationAction = {
      ...action,
      shape: nextArrowPos.shape,
      s: Helper.transposeCoord([0, 0], court),
      m: Helper.transposeCoord(
        [
          nextArrowPos.m[0] - nextArrowPos.s[0],
          nextArrowPos.m[1] - nextArrowPos.s[1],
        ],
        court
      ),
      e: Helper.transposeCoord(
        [
          nextArrowPos.e[0] - nextArrowPos.s[0],
          nextArrowPos.e[1] - nextArrowPos.s[1],
        ],
        court
      ),
      h1: nextArrowPos.h1
        ? Helper.transposeCoord(
            [
              nextArrowPos.h1[0] - nextArrowPos.s[0],
              nextArrowPos.h1[1] - nextArrowPos.s[1],
            ],
            court
          )
        : undefined,
      h2: nextArrowPos.h2
        ? Helper.transposeCoord(
            [
              nextArrowPos.h2[0] - nextArrowPos.s[0],
              nextArrowPos.h2[1] - nextArrowPos.s[1],
            ],
            court
          )
        : undefined,
    };

    let animationPath = Helper.createPathV2(animationAction, [], 0);

    let lenghtOfAnimationPath = Helper.calculateLengthOfCurve(
      nextArrowPos.shape,
      nextArrowPos.s,
      nextArrowPos.m,
      nextArrowPos.e,
      nextArrowPos.h1,
      nextArrowPos.h2
    );

    let duration = Math.min(Math.max(0.5, lenghtOfAnimationPath * 0.04), 1.5);

    if (changes?.type === "MOVE_PLAYER") {
      try {
        if (playerTeam === "defense_alt") {
          timeline.to(
            "#" + prefix + "_" + changes.id + " .stance_path",
            {
              display: "none",
              duration: 0,
            },
            startTS
          );

          timeline.to(
            "#" + prefix + "_" + changes.id + " .rotation_wrapper",
            {
              transform: "rotate(" + (action.angle ?? 0) + "deg)",
              duration: 0,
            },
            startTS
          );

          timeline.to(
            "#" + prefix + "_" + changes.id + " .rotate_text",
            {
              transform: "rotate(" + (action.angle ?? 0) * -1 + "deg)",
              duration: 0,
            },
            startTS
          );
        }
        timeline.to(
          "#" + prefix + "_" + changes.id,
          {
            motionPath: {
              path: animationPath,
              offsetX: changes.offset[0],
              offsetY: changes.offset[1],
            },
            duration: duration,
            autoRound: false,
          },
          startTS
        );

        if (playerTeam === "defense_alt") {
          timeline.to("#" + prefix + "_" + changes.id + " .stance_path", {
            display: "block",
            duration: 0,
          });
        }
      } catch (error) {
        console.log("error", error);
      }
    } else if (changes?.type === "MOVE_BALL") {
      try {
        let ballEl = document.querySelector(
          "#" + prefix + "_" + changes.id + "_ball"
        );
        let reveiverBallEl = document.querySelector(
          "#" + prefix + "_" + changes.reveiverId + "_ball"
        );
        timeline.to(
          ballEl,
          {
            translateX: 0,
            translateY: 0,
            ease: drawEasing,
            duration: 0,
            autoRound: false,
          },
          startTS
        );

        timeline.to(
          ballEl,
          {
            motionPath: {
              path: animationPath,
              autoRound: false,
            },
            duration: duration,
          },
          startTS
        );

        timeline.to(reveiverBallEl, {
          opacity: 1,
          duration: 0,
        });
        timeline.to(ballEl, {
          opacity: 0,
          translateX: 0,
          translateY: 0,
          duration: 0,
        });
      } catch (error) {
        console.log("error", error);
      }
    }
  }
};

const drawActions = (prefix, timeline, action, inAnimator = false) => {
  let arrowPathMask = document.querySelector(
    "#mask_" + prefix + "_" + action.id + " path"
  );
  let arrowPathMaskMarker = document.querySelector(
    "#mask_" + prefix + "_" + action.id + "_arrow_marker > * "
  );

  var startTS, drawnTS;

  startTS = timeline.duration();

  if (inAnimator) {
    //highlight current action in timeline
    timeline.to(
      "#animation_order_" + action.id,
      {
        opacity: 1,
        ease: drawEasing,
        duration: 0.3,
      },
      "-=0.3"
    );
    //timeline.to("#animation_order_" + action.id, {}, "=-0.3");
  }

  if (action.type === "arrow" && arrowPathMask) {
    let length = Helper.calculateLengthOfCurve(
      action.shape,
      action.s,
      action.m,
      action.e,
      action.h1,
      action.h2
    );

    let duration = Math.min(Math.max(0.2, length * 0.03), 1.5);

    //slowly remove mask of arrow to draw arrow
    timeline.to(arrowPathMask, {
      strokeDashoffset: 0,
      autoRound: false,
      ease: drawEasing,
      duration: duration,
    });

    //remove mask for marker to reveal arrowheads
    timeline.to(
      arrowPathMaskMarker,
      {
        opacity: 1,
        duration: 0.05,
      },
      "-=0.05"
    );

    //this is the timestamps where all arrows are drawn and 1 second before the get removed again
    drawnTS = timeline.duration();
  }

  if (action.subType === "handoff") {
    //reveal handoff sign
    timeline.to("#mask_" + prefix + "_" + action.id + " rect", {
      opacity: 1,
      duration: 0,
    });
    drawnTS = timeline.duration();
  }

  if (nonMovingActions.includes(action.subType)) {
    //reveal text
    timeline.to("#" + prefix + "_" + action.id, {
      opacity: 1,
      duration: 0,
    });
  }

  drawnTS = timeline.duration();
  return { start: startTS, arrowFullyDrawn: drawnTS };
};

const removeActions = (prefix, timeline, action, first, pauses = []) => {
  let arrowPathMask = document.querySelector(
    "#mask_" + prefix + "_" + action.id + " path"
  );

  let length = arrowPathMask?.getTotalLength();

  let arrowPathMaskMarker = document.querySelector(
    "#mask_" + prefix + "_" + action.id + "_arrow_marker :first-child"
  );

  if (action.type === "arrow" && arrowPathMask) {
    if (first) {
      addPause(timeline, 1, pauses);
    }
    timeline.to(arrowPathMask, {
      strokeDashoffset: length,
      strokeDasharray: length,
      ease: drawEasing,
      duration: 0,
      autoRound: false,
    });
    timeline.to(arrowPathMaskMarker, {
      opacity: 0,
      duration: 0,
    });
  }

  if (action.subType === "handoff") {
    timeline.to(
      "#mask_" + prefix + "_" + action.id + " rect",
      {
        opacity: 0,
        duration: 0,
      },
      first ? "+=1" : "+=0"
    );
  }

  if (
    nonMovingActions.includes(action.subType) &&
    action.animationType === "pause"
  ) {
    timeline.to({}, {}, "+=" + action.pause);

    timeline.to("#" + prefix + "_" + action.id, {
      opacity: 0,
      duration: 0,
    });
  }

  return { end: timeline.duration() };
};

const initialStateOfArrows = (steps, timeline, prefix) => {
  steps.forEach((step, index) => {
    let action = step.action;

    if (nonMovingActions.includes(action.subType)) {
      timeline.to(
        "#" + prefix + "_" + action.id,
        {
          opacity: 0,
          duration: 0,
        },
        0.0001
      );
    }

    if (action.subType === "handoff") {
      timeline.to(
        "#mask_" + prefix + "_" + action.id + " rect",
        {
          opacity: 0,
          duration: 0,
        },
        0.0001
      );
    } else if (maskedActions.includes(action.subType)) {
      let svgLength =
        document
          .querySelector("#mask_" + prefix + "_" + action.id + " path")
          ?.getTotalLength() ?? 0;

      timeline.to(
        "#mask_" + prefix + "_" + action.id + " path",
        {
          strokeDashoffset: svgLength,
          strokeDasharray: svgLength,
          autoRound: false,
          duration: 0,
        },
        0.0001
      );

      timeline.to(
        "#mask_" + prefix + "_" + action.id + "_arrow_marker > *  ",
        {
          opacity: 0,
          duration: 0,
        },
        0.0001
      );
    }
  });
};

const initialStateOfPlayers = (players, timeline, prefix) => {
  for (let player of players) {
    let ballEl = document.querySelector(
      "#" + prefix + "_" + player.id + "_ball"
    );

    timeline.to(ballEl, {
      opacity: player.team === "ball" ? 1 : 0,
      translateX: 0,
      translateY: 0,
      duration: 0,
    });
  }
};

const changeAnimationPhase = (
  timeline,
  currentPhase,
  previousPhase,
  prefix = "dialog_",
  first,
  pauses = []
) => {
  if (previousPhase) {
    timeline.to("#" + prefix + "phase_note_" + previousPhase.id, {
      display: "none",
      duration: 0,
    });

    timeline.to("#" + prefix + "wrapper_" + previousPhase.id, {
      opacity: 0,
      duration: 0,
    });
  }

  timeline.to("#" + prefix + "phase_note_" + currentPhase.id, {
    display: "block",
    duration: 0,
  });

  if (!first) {
    timeline.to("#" + prefix + "wrapper_" + currentPhase.id, {
      opacity: 1,
      duration: 0,
    });
  }

  if (currentPhase.showOverlay) {
    timeline.to("#" + prefix + "phase_screen_" + currentPhase.id, {
      opacity: 1,
      duration: first ? 0 : 0.2,
    });

    addPause(timeline, currentPhase.showOverlayDuration ?? 1, pauses);

    timeline.to("#" + prefix + "phase_screen_" + currentPhase.id, {
      opacity: 0,
      duration: 0.2,
    });
  }
};

const drawPhase = (
  timeline,
  animationSteps,
  prefixGenerator,
  timestamps,
  court,
  inAnimator = false
) => {
  animationSteps.forEach((step) => {
    // first step Draw Actions (arrows / handoff sign)
    step.forEach((subStep) => {
      let prefix = prefixGenerator(subStep.phaseId);
      let finishedDrawingArrow = drawActions(
        prefix,
        timeline,
        subStep.action,
        inAnimator
      );
      timestamps.push(finishedDrawingArrow);
    });

    step.forEach((subStep, index) => {
      let prefix = prefixGenerator(subStep.phaseId);
      removeActions(prefix, timeline, subStep.action, index === 0);
    });

    let timestampBeforeMoving = timeline.duration();
    step.forEach((subStep) => {
      let prefix = prefixGenerator(subStep.phaseId);
      moveActions(prefix, timeline, subStep, timestampBeforeMoving, court);
    });

    if (inAnimator) {
      for (let subStep of step) {
        timeline.to(
          "#animation_order_" + subStep.action.id,
          {
            opacity: 0,
            duration: 0.3,
          },
          "-=0.3"
        );
      }
    }
  });
};

export {
  drawPhase,
  createAnimationSteps,
  moveActions,
  drawActions,
  removeActions,
  initialStateOfArrows,
  initialStateOfPlayers,
  changeAnimationPhase,
  nonMovingActions,
  drawStaticActions,
  addPause,
};
